/**
 * Settings constants
 */
export const FETCH_RESOURCES_FOLDERS_START = '[Resources] FETCH_RESOURCES_FOLDERS_START';
export const FETCH_RESOURCES_FOLDERS_FAIL = '[Resources] FETCH_RESOURCES_FOLDERS_FAIL';
export const SET_RESOURCES_FOLDERS = '[Resources] SET_RESOURCES_FOLDERS';
export const FETCH_RESOURCES_ITEMS_START = '[Resources] FETCH_RESOURCES_ITEMS_START';
export const FETCH_RESOURCES_ITEMS_FAIL = '[Resources] FETCH_RESOURCES_ITEMS_FAIL';
export const SET_RESOURCES_ITEMS = '[Resources] SET_RESOURCES_ITEMS';
export const FETCH_RESOURCES_ITEM_STRING_START = '[Resources] FETCH_RESOURCES_ITEM_STRING_START';
export const FETCH_RESOURCES_ITEM_STRING_FAIL = '[Resources] FETCH_RESOURCES_ITEM_STRING_FAIL';
export const SET_RESOURCES_ITEM_STRING = '[Resources] SET_RESOURCES_ITEM_STRING';
